import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { addSpacesToTypeName } from 'src/app/pipes/split-enum-strings/add-spaces.pipe';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { systemLogTypeOptionSelectors } from '../state/system-logs-type-select-option.reducer';
import { SystemLogTypeOption } from '../system-logs-type-option.interface';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: SystemLogTypeSelectComponent,
        },
    ],
    selector: 'ndt-system-logs-type-select',
    templateUrl: './system-logs-type-select.component.html',
    standalone: false
})
export class SystemLogTypeSelectComponent extends LcsSingleSelectBase<SystemLogTypeOption> implements OnInit {
   systemLogTypes$: Observable<SystemLogTypeOption[] | null>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.systemLogTypes$ = this.store.pipe(
         select(systemLogTypeOptionSelectors.selectFilteredItems),
         map((items: Array<SystemLogTypeOption>) => {
            let filteredItems = items;

            return filteredItems;
         })
      );
   }

   displayWith(item: SystemLogTypeOption | null): string | null {
      return item ? (item.name ? addSpacesToTypeName(item.name) : null) : null;
   }

   trackBy(item: SystemLogTypeOption | null) {
      return item ? item.systemLogTypeId : null;
   }
}
